import { render } from "./LegacyTriggerWaiting.vue?vue&type=template&id=7870e615"
import script from "./LegacyTriggerWaiting.vue?vue&type=script&lang=js"
export * from "./LegacyTriggerWaiting.vue?vue&type=script&lang=js"
script.render = render

export default script